import {videoPreviewOptions} from "./videoPreviewOptions";

// THIS IS CURRENTLY HARDCODED FOR VIDEO PREVIEW
jQuery.fn.extend({
    fitVideoText: function () {
        return this.each(function () {
            let width = jQuery(this).width();
            let height = jQuery(this).height();

            // only elements that have width
            if (width > 0 && height > 0) {
                let desiredWidthRatio = 1 - (1080 - 800) / 1080;
                let desiredWidth = 478 * desiredWidthRatio;
                let scaleFactor = 1 / (width / desiredWidth);

                if (scaleFactor < 1) {
                    jQuery(this).css('transform', 'scale(' + scaleFactor + ')');
                }
            }
        });
    },
});

export class CreateVideoPreviewSlides {
    constructor(imagesArray) {
        this.imagesArray = imagesArray;
        this.agentSlideBackgroundImage = imagesArray[0].image_source_trimmed ? imagesArray[0].image_source_trimmed : imagesArray[0].image_source_high_resolution; // first one is re-used on agent slide

        this.create();
        this.events();
    }

    events() {
        jQuery(window).resize(this.onResize.bind(this));
    }

    onResize(event) {
        let windowWidth = jQuery(window).width();
        if (windowWidth < 520) {

            // Scale down the video preview area to fit in the container wrapper (92.5%)
            let scale = Math.min(
                1 / (478 / jQuery('.video-slideshow__wrap-wrap--js').width()),
                1 / (windowWidth * 0.925 / jQuery('.video-slideshow__wrap-wrap--js').width()),
            );

            jQuery('.video-slideshow__wrap-wrap--js').css('transform', 'scale(' + scale + ')');
        } else {
            jQuery('.video-slideshow__wrap-wrap--js').css('transform', '');
        }
    }

    /**
     * Let it be
     */
    create() {
        let index = this.createVideoSlides();
        this.createAgentVideoSlide(index++);
        this.createBrokerageVideoSlide(index++);
    }

    /**
     * Create the first chunk of slides with single line of text alternating top-bottom.
     * @returns {*}
     */
    createVideoSlides(i = 0) {

        // Takes the return from the slideshow handler and turns it into html
        for (i = 0; i < this.imagesArray.length; i++) {
            this.createVideoSlide(this.imagesArray[i], i);
        }

        return i;
    }

    /**
     * @param imageArray
     * @param index
     */
    createVideoSlide(imageArray, index) {
        let imageSrcHighRes = imageArray.image_source_trimmed ? imageArray.image_source_trimmed : imageArray.image_source_high_resolution;
        let imageCaption = imageArray.image_caption;

        // text(null) gives us a string 'null' in the DOM
        if (imageCaption === null) {
            imageCaption = '';
        }

        let $referenceInSecondModal = imageArray['$ref'];

        let $slideNoJS = jQuery(videoPreviewOptions.handlers.videoSlideTemplateOnlyHandler)
            .clone()
            .removeClass(videoPreviewOptions.classes.videoSlideTemplateOnly)
            .removeClass(videoPreviewOptions.classes.slideShowTemplateOnly);

        // If the reference field was defined ...
        if ($referenceInSecondModal.length > 0) {

            // clear out anything old
            let $secondModalWrapper = $referenceInSecondModal.find('.video-slideshow__slide-wrap--js');
            $secondModalWrapper.empty();

            // Append the new DOM elements
            $slideNoJS.appendTo($secondModalWrapper);

            // Add original captions (if defined)
            $referenceInSecondModal.find('.video-image-caption--js').val(imageCaption);
        }

        // clone slide template HTML
        let $slide = $slideNoJS.clone().attr('data-slide-index', index)
            .addClass(videoPreviewOptions.classes.videoSlideBase + '--' + index)
            .addClass(videoPreviewOptions.classes.videoSlide)
            .appendTo(videoPreviewOptions.handlers.videoSlideShowHandler);

        let $slides = $slide.add($slideNoJS);

        // Add caption
        $slides.find(videoPreviewOptions.handlers.videoSlideCaptionHandler).text(imageCaption);
        $referenceInSecondModal.closest();

        $slides.find('img').attr('src', imageSrcHighRes);
    }

    isClientOnFastInternet() {
        return typeof navigator !== 'undefined' && typeof navigator.connection !== 'undefined' && navigator.connection.downlink > 1.2
    }

    getAgentImageElement() {
        return jQuery('input[name="agent_photo_url"]');
    }

    getAgentImageSource() {
        return this.getAgentImageElement().val();
    }

    getAgentName() {
        return this.getAgentNameElement().val();
    }

    getAgentNameElement() {
        return jQuery('input[name="social_ad_primary_text"]');
    }

    getBrokerageNameElement() {
        return jQuery('input[name="social_ad_secondary_text"]');
    }

    getBrokerageName() {
        return this.getBrokerageNameElement().val();
    }

    /**
     * create the agent slide (second to last, agent photo over first image w/ info)
     * @param index
     */
    createAgentVideoSlide(index) {
        let agentPhotoImage = this.getAgentImageSource();
        let agentName = this.getAgentName();
        let brokerageName = this.getBrokerageName();
        let $slideTemplate;

        let $template = jQuery(videoPreviewOptions.handlers.agentSlideTemplate)
            .clone()
            .removeClass(videoPreviewOptions.classes.agentSlideTemplate)
            .removeClass(videoPreviewOptions.classes.agentSlideTemplateOnlyFrontEnd)
            .addClass(videoPreviewOptions.classes.videoSlide);

        if (jQuery(videoPreviewOptions.handlers.agentSlidePreviewHandler).length > 0) {
            $template.appendTo(videoPreviewOptions.handlers.agentSlidePreviewHandler);
            $slideTemplate = $template.clone()
        } else {
            $slideTemplate = $template
        }

        $slideTemplate.addClass(videoPreviewOptions.classes.videoSlideBase + '--' + index)
            .attr('data-slide-index', index)
            .appendTo(videoPreviewOptions.handlers.videoSlideShowHandler);

        let $templates = $slideTemplate.add($template);

        jQuery($templates).find('img').attr('src', this.agentSlideBackgroundImage);
        jQuery($templates).find(videoPreviewOptions.handlers.agentName).text(agentName);
        jQuery($templates).parent().parent().find(videoPreviewOptions.handlers.agentEditModalAgentName).val(agentName);
        jQuery($templates).find(videoPreviewOptions.handlers.agentImage).attr('src', agentPhotoImage);
        jQuery($templates).find(videoPreviewOptions.handlers.brokerName).text(brokerageName);
    }

    /**
     * Create the last slide with broker info and phone number and stuff
     * @param index
     */
    createBrokerageVideoSlide(index) {
        let brokeragePhoto = jQuery('input[name="broker_image"]').val();
        let agentPhone = jQuery('input[name="agent_phone"]').val();
        let agentEmail = jQuery('input[name="agent_email"]').val();
        let agentWebsite = jQuery('input[name="agent_website"]').val();
        let videoCTA = jQuery('input[name="video_cta"]').val();
        let $slideTemplate;

        let $template = jQuery(videoPreviewOptions.handlers.brokerSlide.template)
            .clone()
            .removeClass(videoPreviewOptions.classes.brokerSlide.template)
            .removeClass(videoPreviewOptions.classes.brokerSlide.templateFrontEnd)
            .addClass(videoPreviewOptions.classes.videoSlide);


        if (jQuery(videoPreviewOptions.handlers.brokerSlidePreviewHandler).length) {
            $template.appendTo(videoPreviewOptions.handlers.brokerSlidePreviewHandler);

            $slideTemplate = $template.clone();
        } else {
            $slideTemplate = $template
        }

        $slideTemplate.addClass(videoPreviewOptions.classes.videoSlideBase + '--' + index)
            .attr('data-slide-index', index)
            .appendTo(videoPreviewOptions.handlers.videoSlideShowHandler);

        let $templates = $template.add($slideTemplate);

        if (brokeragePhoto) {
            jQuery($templates).find(videoPreviewOptions.handlers.brokerSlide.brokerImage).attr('src', brokeragePhoto);
        }

        jQuery($templates).find(videoPreviewOptions.handlers.brokerSlide.agentPhone).text(agentPhone).fitVideoText();
        jQuery($templates).find(videoPreviewOptions.handlers.brokerSlide.agentEmail).text(agentEmail).fitVideoText();
        jQuery($templates).find(videoPreviewOptions.handlers.brokerSlide.agentWebsite).text(agentWebsite).fitVideoText();
        jQuery($templates).find(videoPreviewOptions.handlers.brokerSlide.cta).text(videoCTA).fitVideoText();
    }
}